import axios from "axios"
import {
  EDIT_DOLLAR_SETTINGS_FAIL,
  EDIT_DOLLAR_SETTINGS_REQUEST,
  EDIT_DOLLAR_SETTINGS_SUCCESS,
  GET_DOLLAR_SETTINGS_FAIL,
  GET_DOLLAR_SETTINGS_REQUEST,
  GET_DOLLAR_SETTINGS_SUCCESS,
  GET_INTEREST_INFO_FAIL,
  SET_DOLLAR_SETTINGS_FAIL,
  SET_DOLLAR_SETTINGS_REQUEST,
  SET_DOLLAR_SETTINGS_SUCCESS
} from "../constants/adminConstants"
import { BASE_API_URL } from "../constants/dropdown"

export const fetchDollarWalletSettings = () => async (dispatch, getState) => {
  try {
    dispatch({
      type: GET_DOLLAR_SETTINGS_REQUEST
    })

    const {
      admin2faLogin: { userInfo }
    } = getState()
    const token = userInfo?.token?.access_token
    const config = {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${token}`
      }
    }

    const { data } = await axios.get(
      `${BASE_API_URL}/admin/dollar/setting`,
      config
    )

    dispatch({
      type: GET_DOLLAR_SETTINGS_SUCCESS,
      payload: data
    })
  } catch (error) {
    console.log(error)
    dispatch({
      type: GET_DOLLAR_SETTINGS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message
    })
  }
}

export const createDollarWalletSettings =
  (reqData) => async (dispatch, getState) => {
    try {
      console.log("creating settings")
      dispatch({
        type: SET_DOLLAR_SETTINGS_REQUEST
      })

      const {
        admin2faLogin: { userInfo }
      } = getState()
      const token = userInfo?.token?.access_token
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
      const createData = {
        buy_conversion_rate: reqData.buy_conversion_rate,
        sell_conversion_rate: reqData.sell_conversion_rate,
        minimum_funding: reqData.minimum_funding,
        maximum_funding: reqData.maximum_funding,
        buy_issuable_amount: reqData.buy_issuable_amount,
        sell_issuable_amount: reqData.sell_issuable_amount,
        maximum_withdrawal: reqData.maximum_withdrawal,
        minimum_withdrawal: reqData.minimum_withdrawal
      }

      // getting our response as we set it in our userController in the backend
      const { data } = await axios.post(
        `${BASE_API_URL}/admin/dollar/setting`,
        createData,
        config
      )
      dispatch({
        type: SET_DOLLAR_SETTINGS_SUCCESS,
        payload: data
      })
    } catch (error) {
      console.log(error)
      dispatch({
        type: SET_DOLLAR_SETTINGS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }

export const updateDollarWalletSettings =
  (id, reqData) => async (dispatch, getState) => {
    try {
      console.log("creating settings")
      dispatch({
        type: EDIT_DOLLAR_SETTINGS_REQUEST
      })

      const {
        admin2faLogin: { userInfo }
      } = getState()
      const token = userInfo?.token?.access_token
      const config = {
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`
        }
      }
      const createData = {
        buy_conversion_rate: reqData.buy_conversion_rate,
        sell_conversion_rate: reqData.sell_conversion_rate,
        minimum_funding: reqData.minimum_funding,
        maximum_funding: reqData.maximum_funding,
        buy_issuable_amount: reqData.buy_issuable_amount,
        sell_issuable_amount: reqData.sell_issuable_amount,
        maximum_withdrawal: reqData.maximum_withdrawal,
        minimum_withdrawal: reqData.minimum_withdrawal
      }

      // getting our response as we set it in our userController in the backend
      const { data } = await axios.put(
        `${BASE_API_URL}/admin/dollar/setting?id=${id}`,
        createData,
        config
      )
      dispatch({
        type: EDIT_DOLLAR_SETTINGS_SUCCESS,
        payload: data
      })
    } catch (error) {
      console.log(error)
      dispatch({
        type: EDIT_DOLLAR_SETTINGS_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message
      })
    }
  }
